import { useRef, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import moment from "moment";
import "./PdfCartaApresentacao.scss";

function PdfCartaApresentacao({
  clinica,
  data,
  instituicoes,
  instituicao,
  auth,
  onClose,
}) {
  const componentRef = useRef();
  const dataFormatada = moment(data).format("D [de] MMMM [de] YYYY");

  const instituicaoSelecionada =
    instituicoes.find((i) => i.value === instituicao)?.label || "INPS";

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Carta-Apresentacao-${instituicaoSelecionada}-${moment(data).format("DD-MM-YYYY")}`,
    onAfterPrint: () => onClose(),
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    handlePrint();
  }, [handlePrint]);

  return (
    <div ref={componentRef} className="pdf-carta-wrapper">
      <div className="pdf-carta-cabecalho">
        <div className="pdf-carta-cabecalho-left">
          <img
            src={`${process.env.REACT_APP_BACKEND_LINK}/${clinica.logotipo}`}
            alt="Logo"
            className="pdf-carta-logo"
          />
        </div>
        <div className="pdf-carta-cabecalho-right">
          <span className="clinica-nome-carta">{clinica.nome}</span>
          <span>Telef: {clinica.contacto}</span>
          <span>{clinica.endereco}</span>
          <span>NIF: {clinica.nif}</span>
        </div>
      </div>

      <div className="pdf-carta-destinatario__container">
        <div></div>
        <div className="pdf-carta-destinatario">
          <p>Ao</p>
          <p className="destinatario-nome">
            {instituicaoSelecionada.toUpperCase() === "INPS"
              ? "Instituto Nacional de Previdência Social"
              : instituicaoSelecionada ||
                "Instituto Nacional de Previdência Social"}
          </p>
          {clinica.ilha && <p>{clinica.ilha}</p>}
          <p>
            {clinica.ilha ? `${clinica.ilha}, ${dataFormatada}` : dataFormatada}
          </p>
        </div>
      </div>

      <div className="pdf-carta-corpo">
        <p>
          Junto, enviamos Credenciais, Fatura e a relação dos Beneficiários de
          tratamentos dentários desta Instituição.
        </p>
      </div>

      <div className="pdf-carta-fecho-assinatura">
        <p>Sem mais de momento, subscrevemo-nos.</p>
        <p className="atenciosamente">Atenciosamente</p>
        <div className="assinatura-espaco"></div>
        <p>O Médico Dentista</p>
      </div>
    </div>
  );
}

export default PdfCartaApresentacao;
